/* eslint-disable no-restricted-imports */
import styled from 'styled-components';
import { Box } from '../../../ui/layout/Box';
import { Flex, FlexProps } from '../../../ui/layout/Flex';

export const MainContainer = styled(Flex)
    .withConfig({ displayName: 'CollectionDetailsMainContainer' })
    .attrs<FlexProps>({
        direction: 'column',
        height: '100%',
        width: '100%',
        pt: { xs: 0, sm: 2 },
        position: 'relative',
    })``;

export const ScrollableContainer = styled(Box)
    .withConfig({ displayName: 'CollectionDetailsScrollableContainer' })
    .attrs({
        height: '100%',
        width: '100%',
        overflowY: 'auto',
        disableScrollbar: true,
        backgroundColor: 'var(--background-primary)',
        borderRadius: { xs: 0, sm: '24px 24px 0 0' },
    })``;
